import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const PieChart14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_171)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7 0.25C6.58579 0.25 6.25 0.585786 6.25 1V7C6.25 7.50899 6.77004 7.87675 7.24993 7.70713L12.9085 5.70713C13.2836 5.57456 13.4983 5.12515 13.3657 4.75007C12.4394 2.12939 9.94016 0.25 7 0.25ZM7.75 5.93945V1.80318C9.44667 2.0459 10.8826 3.09995 11.6504 4.56086L7.75 5.93945Z'
        fill='currentColor'
      />
      <path
        d='M2.25 7.00001C2.25 4.9872 3.50223 3.26503 5.27283 2.57356L4.72717 1.17633C2.40041 2.085 0.75 4.34884 0.75 7.00001C0.75 10.4518 3.54822 13.25 7 13.25C10.4518 13.25 13.25 10.4518 13.25 7.00001H11.75C11.75 9.62336 9.62335 11.75 7 11.75C4.37665 11.75 2.25 9.62336 2.25 7.00001Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_171'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

PieChart14.displayName = 'PieChart14';
export default PieChart14;
